import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPaperPlane: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconPaperPlane"><Path d="M2.51236 4.62782C2.00011 3.3472 3.34223 2.11227 4.57589 2.7291L20.4345 10.6584C21.5401 11.2112 21.5401 12.7889 20.4345 13.3417L4.5759 21.271C3.34224 21.8878 2.00011 20.6529 2.51236 19.3723L5.26127 12.5H9.49977C9.77591 12.5 9.99977 12.2761 9.99977 12C9.99977 11.7239 9.77591 11.5 9.49977 11.5H5.26123L2.51236 4.62782Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPaperPlane;
